import { apolloClient } from '@/apollo';
import { QueryOptions, MutationOptions, ApolloQueryResult, FetchResult } from 'apollo-boost';
import loaderService from '@/services/loader.service';

export class Resource {
  public static query(options: QueryOptions, field?: string) {
    options.fetchPolicy = 'network-only';
    return this.makeRequest(apolloClient.query(options), field);
  }

  public static mutation(options: MutationOptions, field?: string) {
    options.fetchPolicy = 'no-cache';
    return this.makeRequest(apolloClient.mutate(options), field);
  }

  private static async makeRequest(request: Promise<any>, field?: string) {
    loaderService.start();
    try {
      return this.handleResponse(await request, field);
    } catch (error) {
      loaderService.end();
      throw error;
    }
  }

  private static handleResponse(response: ApolloQueryResult<any> | FetchResult, field?: string) {
    loaderService.end();
    if (response.errors) {
      throw response.errors;
    }
    if (field && response.data[field] === undefined) {
      throw new Error(`Nie uzyskano odpowiedzi od serwera`);
    }
    return field && response.data ? response.data[field] : response.data;
  }
}
